import React, { useEffect, useMemo, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'react-redux';
import SideBarListStyles from '../../../styles/SideBarListStyle';
import FloatButton from '../../sidebar/FloatButton';
import ShowProgress from '../../ui/Backdrop';
import AdminUserAddNewPopup from './AdminUserAddNewPopup';
import useAdminUsers from '../hooks/useAdminUsers';

const SidebarListAdminUsers = ({ filterArray = [] }) => {
  const classes = SideBarListStyles();
  const { getDetail } = useAdminUsers();
  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = useState(false);
  const selectedId = useSelector((state) => state.adminUsersData.selectedId);

  const myRefs = useMemo(
    () =>
      filterArray?.reduce((acc, val) => {
        acc[val.id] = React.createRef();
        return acc;
      }, {}),
    [filterArray],
  );

  useEffect(() => {
    if (myRefs[selectedId]) {
      myRefs[selectedId].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedId, myRefs]);

  const toggleAddNewPopup = () => setIsAddNewPopupOpen((prev) => !prev);

  const renderListItem = (data) => {
    const isSelected = selectedId === data.id;
    const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || data.email;

    return (
      <div key={data.id} className={isSelected ? classes.highlightItem : ''}>
        <ListItem
          button
          selected={isSelected}
          className={classes.listStyling}
          onClick={() => getDetail(data.id)}
          ref={myRefs[data.id]}
        >
          <ListItemText
            primary={<p className={isSelected ? classes.listTextSelected : classes.listTextNonSelected}>{fullName}</p>}
            secondary={
              <div className={isSelected ? classes.listSubTextSelected : classes.listSubTextNonSelected}>
                <div className={classes.listSubTextJustify}>
                  <div>{data.email}</div>
                  <div className={!data.enabled ? classes.secondaryTextRed : null}>
                    {data.enabled ? 'Active' : 'Inactive'}
                  </div>
                </div>
              </div>
            }
          />
        </ListItem>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="admin users list">
        {filterArray.map(renderListItem)}
      </List>
      <FloatButton
        fabs={[{ color: 'primary', className: classes.fab, icon: <AddIcon />, label: 'Add' }]}
        value={0}
        mainTabID={23}
        onAddNewAdminUser={toggleAddNewPopup}
      />
      {isAddNewPopupOpen && <AdminUserAddNewPopup close={toggleAddNewPopup} />}
      <ShowProgress />
    </div>
  );
};

export default SidebarListAdminUsers;
